import { faBellRing, faExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

export type CriticalAlarmIconProps = Omit<
    FontAwesomeIconProps,
    'icon' | 'mask' | 'transform'
>;

export function CriticalAlarmIcon(props: CriticalAlarmIconProps) {
    return (
        <FontAwesomeIcon
            {...props}
            icon={faExclamation}
            mask={faBellRing}
            transform="shrink-8"
        />
    );
}
